import React from 'react';
import StaticContent from 'components/StaticContent';
import withMainLayout from 'with/withMainLayout';

function HelpPage() {
  return <StaticContent src="/help" />;
}

export default withMainLayout(HelpPage);
